export enum MigrationSettingsDataType {
    outlookForWindows,
    outlookForWeb,
}

export default interface MigrationSettingsData {
    currentMigrationType: MigrationSettingsDataType;
}
